<template>
	<section>
		<div class="tab-content">
			<h2>{{ type && list[type]['tit'] }}</h2>
			<div class="tab" v-if="type == 'images' || type == 'product'">
				<span v-for="(val, key, index) in tabType" :key="index" @click="tab(key)" :class="{ active: val }"><i class="el-icon-s-data"></i> {{ key }}</span>
			</div>
		</div>
		<component :is="type && list[type]['com']" :data="data" @changeTab="tab"></component>
	</section>
</template>

<script>
import Info from '@/components/Edit/Info';
import Images from '@/components/Edit/Image';
import Product from '@/components/Edit/Product';
import text_config from '@/components/Edit/text_config';
import button_config from '@/components/Edit/button_config';
import imageAndText from '@/components/Edit/imageAndText';
import videoAndText from '@/components/Edit/videoAndText';
import fromInfo from '@/components/Edit/fromInfo';
import video_config from '@/components/Edit/video_config';
import bookShelf from '@/components/Edit/bookShelf';
import courseVideo from '@/components/Edit/courseVideo';
import courseCatalogue from '@/components/Edit/courseCatalogue';
import bookLink from '@/components/Edit/bookLink';
import CourseIntroduction from '@/components/Edit/CourseIntroduction';
import relatedReading from '@/components/Edit/relatedReading';
import doctorsSharing from '@/components/Edit/doctorsSharing';
import combinedMedica from '@/components/Edit/combinedMedica';
import productDisplay from '@/components/Edit/productDisplay';

export default {
	name: 'EditForm',
	components: {
		Info,
		Images,
		Product,
		text_config,
		button_config,
		imageAndText,
		videoAndText,
		fromInfo,
		video_config,
		bookShelf,
		courseVideo,
		courseCatalogue,
		bookLink,
		CourseIntroduction,
		relatedReading,
		doctorsSharing,
		combinedMedica,
		productDisplay,
	},
	props: {
		data: {
			type: Object,
			default: () => {},
		},
	},
	data() {
		return {
			type: '',
			list: {
				info: {
					tit: '页面信息',
					com: 'Info',
				},
				images: {
					tit: '图片',
					com: 'Images',
				},
				banner: {
					tit: '轮播图',
					com: 'Images',
				},
				product: {
					tit: '商品',
					com: 'Product',
				},
				text_component: {
					tit: '文字',
					com: 'text_config',
				},
				button_component: {
					tit: '表单按钮',
					com: 'button_config',
				},
				imageAndText: {
					tit: '图文组件',
					com: 'imageAndText',
				},
				videoAndText: {
					tit: '视文组件',
					com: 'videoAndText',
				},
				fromInfo: {
					tit: '表单信息',
					com: 'fromInfo',
				},
				video_component: {
					tit: '视频组件',
					com: 'video_config',
				},
				bookShelf: {
					tit: '书架组件',
					com: 'bookShelf',
				},
				courseVideo: {
					tit: '课程视频',
					com: 'courseVideo',
				},
				courseCatalogue: {
					tit: '课程目录',
					com: 'courseCatalogue',
				},
				bookLink: {
					tit: '跳转信息',
					com: 'bookLink',
				},
				CourseIntroduction: {
					tit: '课程简介',
					com: 'CourseIntroduction',
				},
				relatedReading: {
					tit: '相关阅读',
					com: 'relatedReading',
				},
				doctorsSharing: {
					tit: '名医分享',
					com: 'doctorsSharing',
				},
				combinedMedica: {
					tit: '联合用药',
					com: 'combinedMedica',
				},
				productDisplay: {
					tit: '产品展示',
					com: 'combinedMedica',
				},
			},
			tabType: {
				1: true,
				2: false,
				3: false,
			},
		};
	},
	mounted() {
		this.type = this.data.type;
		if (this.data.tabType) {
			this.tab(this.data.tabType);
		}
	},
	methods: {
		tab(key) {
			for (let i in this.tabType) {
				if (key == i) {
					this.tabType[key] = true;
					this.$set(this.data, 'tabType', key);
				} else {
					this.tabType[i] = false;
				}
			}
		},
	},
};
</script>

<style scoped lang="scss">
section {
	height: 100%;
	overflow: hidden;
	display: flex;
	flex-wrap: nowrap;
	flex-direction: column;
}
.tab-content {
	padding: 0 15px;
	h2 {
		font-size: 16px;
		color: #333;
	}
	.tab {
		display: flex;
		justify-content: space-around;
		border: 1px solid #ddd;
		border-radius: 6px;
		span {
			width: 33.33%;
			text-align: center;
			font-size: 14px;
			color: #666;
			display: block;
			height: 36px;
			line-height: 36px;
			cursor: pointer;
			&.active {
				color: #fff;
				background: #409eff;
				border-radius: 2px;
			}
			&:nth-of-type(2) {
				border-left: 1px solid #ddd;
				border-right: 1px solid #ddd;
			}
		}
	}
}
</style>